module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAA3ElEQVQokZXRP0oDURDH8e/YmSDiTrUXsNJOD2BjI2lCLuBhvIaNhJzBxiqFWIoIHsCd6hXmHwGRkVnYZcMq2f3BFG/e+/Aeb8TdacZEj4Bt7um7apvoEPjJPW2r3kFjc2KiH8ACWJro1ETHJvoMrKJM9NFET+N8eaOJ3gL3dEsCLqQgOwQ+gZOOMPIQTz3viSJXAdc9UWQZ8B147Qln1eecAXPguAN6Am7KceSe3oBr4KsDGsU86znmnl724AptYlHDPXgHteA/uIXKxOf8VQXZZUF2V5ANWvvu/AIk+XO2arFp1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/heart.png
// module id = 7EVn
// module chunks = 1